var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[_c('div',{staticClass:"is-bold"},[_vm._v(" Last seen ")]),_vm._v(" "+_vm._s(_vm.relativeLastSeenTime.lastSeen)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }